import { z } from "zod";

/**
 * ================================================================
 * UC HAL — VE UCUNCUSU SEMAYA GEC GELDI
 * ================================================================
 * `bilinmiyor`: bileseni OLCEMEDIK. Ikisinden birini yazmak IDDIA
 * olurdu — "erisilemiyor" yanlis alarm uretir, "calisiyor" calismadigi
 * halde yesil gosterir.
 *
 * ONEMLI: bu deger 04.09.2026'da SUNUCUYA once eklendi, semaya
 * SONRA. Aradaki surede sema `parse` ile duserek panelin butun saglik
 * ekranini "Sunucuya ulasilamadi" ekranina ceviriyordu — yani NE
 * BOZULDUGUNU soylemesi gereken ekran, tam o anda kendisi bozulup
 * sucu sunucuya atiyordu.
 *
 * Ve bir katman daha: `bilinmiyor` ureten TEK bilesen worker'di. Yani
 * hata, onu gormek icin eklenen ozelligin KENDISINI gizliyordu.
 *
 * Ders bugun ucuncu kez ayni: BIR SUNUCU ALANI EKLEMEK, O ALANI
 * KULLANILABILIR YAPMAZ. Sema `z.enum` oldugu icin bu sefer sessiz de
 * degildi — daha kotusuydu, gurultulu ve yanlis yeri isaret ediyordu.
 */
export const bilesenDurumuSemasi = z.object({
  ad: z.string(),
  durum: z.enum(["calisiyor", "erisilemiyor", "bilinmiyor"]),
  hata: z.string().optional(),
});

export const saglikSemasi = z.object({
  durum: z.enum(["saglikli", "sorunlu"]),
  bilesenler: z.array(bilesenDurumuSemasi),
});

export type Saglik = z.infer<typeof saglikSemasi>;
export type BilesenDurumu = z.infer<typeof bilesenDurumuSemasi>;
